import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { updateClinicReq } from "../requests";
import ClinicForm from "./ClinicForm";

const formName = "clinics";
const UpdateClinic = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        id: props.data.id,
        ...data
      }
    }
    makeRequest(setLoader, updateClinicReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("Clinic Updated", res.msg);
    props.onUpdated(data.object);
  }

  const onError = (err) => {
    let errorList = [];
    errorList['name'] = err.name;
  }

  return (
    <DrawerComponent mainTitle="Update" subTitle="Clinic" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <ClinicForm setErrors={ setErrors } errors={ errors } initialData={ props.data } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default UpdateClinic
